import type {CstNode, CstNodeType} from './syntax-tree'

export function isListType(type: CstNodeType): type is 'listUnordered' | 'listOrdered' {
  return type === 'listUnordered' || type === 'listOrdered'
}

type NodeCallback = (node: CstNode) => void

/** Iterate over every node in the tree. */
export function walkCst(node: CstNode, callbacks: {enter: NodeCallback; exit: NodeCallback}): void {
  callbacks.enter(node)
  for (const child of node.children) walkCst(child, callbacks)
  callbacks.exit(node)
}
